import { SearchBox } from 'components';
import { BarcodeCard } from 'components/barcode';
import { TripContext } from 'contexts';
import { CheckBox } from 'devextreme-react/check-box';
import { ScrollView } from 'devextreme-react/scroll-view';
import { SelectBox } from 'devextreme-react/select-box';
import React, { FC, Fragment, useContext, useState } from 'react';
import { LicensePlate, LineItem, Order, OrderItem, ReturnItem, Stop, Trip } from 'services/types';
import './test-barcodes.scss';

export const TestBarcodesPage: FC = () => {
    const tripContext = useContext(TripContext)

    const [query, setQuery] = useState<string>('')
    const [isLpSelected, setIsLpSelected] = useState<boolean>(true)
    const [isItemSelected, setIsItemSelected] = useState<boolean>(true)
    const [isReturnItemSelected, setIsReturnItemSelected] = useState<boolean>(true)
    const [selectedTrip, setSelectedTrip] = useState<Trip>({ } as Trip)
    const [selectedStop, setSelectedStop] = useState<Stop>({ } as Stop)

    const stops: Stop[] = tripContext.stops.toArray() ?? []
    const orders: Order[] = tripContext.orders.filter(o => o.stopId == selectedStop.id)
    const orderItems: OrderItem[] = tripContext.orderItems.filter(oi => orders.some(o => o.id == oi.orderId))
    const lineItems: LineItem[] = tripContext.lineItems.filter(li => orderItems.some(oi => oi.lineItemId == li.id))
    const licensePlates: LicensePlate[] = tripContext.licensePlates.filter(lp => lp.stopId == selectedStop.id)
    const returnItems: ReturnItem[] = tripContext.returnItems.filter(ri => orders.some(o => o.id == ri.orderId))
    const returnItemLineItem: LineItem[] = tripContext.lineItems.filter(li => returnItems.some(ri => ri.lineItemId == li.id))

    const renderStop = (e: any) => {
        const company: string = tripContext.companies.find(c => c.id == e.companyId)?.name ?? "";
        return (
            <div className="test-barcodes-stop-item">
                <div className="test-barcodes-stop-item-name">{company}</div>
                <div className="test-barcodes-stop-item-time">{e.appointmentTime.toString()}</div>
            </div>
        );
    }

    const findStop = (e: any) => {
        if (e != null && e.companyId != null) {
            return tripContext.companies.find(c => c.id == e.companyId)?.name ?? "";
        }
        else
            return "";
    }

    const setLoad = (e: any) => {
        setSelectedTrip(e.value)
        const newStop: Stop = { } as Stop
        setSelectedStop(newStop)
    }

    const filterResults = (): [LineItem[], LicensePlate[], ReturnItem[]] => {
        let filteredItems: LineItem[] = []
        let filteredLps: LicensePlate[] = []
        let filteredReturnItems: ReturnItem[] = []
        if (query?.length > 0) {
            lineItems.forEach(item => {
                const searchValues: string[] = [
                    item.longDescription ?? item.description ?? 'Unknown Item',
                    item.id.toString(),
                    item.manufacturerItemId
                ]
                if (searchValues.some(value => value.toLowerCase().includes(query))) {
                    filteredItems.push(item)
                }
            })
            licensePlates.forEach(lp => {
                if (lp.id.toString().includes(query)) {
                    filteredLps.push(lp)
                }
            })
            returnItems.forEach(ri => {
                const searchValues: string[] = [
                    ri.id.toString(),
                    ri.lineItemId.toString(),
                    ri.orderId.toString(),
                    ri.customerItemId?.toString() ?? { } as string,
                    returnItemLineItem.find(li => li.id == ri.lineItemId)?.longDescription ?? ""
                ]

                if (searchValues.some(value => value.toLowerCase().includes(query))) {
                    filteredReturnItems.push(ri)
                }
            })
        }
        else {
            filteredItems = lineItems
            filteredLps = licensePlates
            filteredReturnItems = returnItems
        }

        filteredItems = isItemSelected ? filteredItems : []
        filteredLps = isLpSelected ? filteredLps : []
        filteredReturnItems = isReturnItemSelected ? filteredReturnItems : []

        return [filteredItems, filteredLps, filteredReturnItems]
    }

    const [filteredItems, filteredLps, filteredReturnItems] = filterResults()
    return (
        <Fragment>
            <div className="test-barcodes-select-load-selectbox-container">
                <div className="test-barcodes-select-label"> Load:</div>
                <div className="test-barcodes-select-box">
                    <SelectBox
                        dataSource={tripContext.trips.toArray()}
                        displayExpr={"loadNumber"}
                        placeholder={"Select a Load"}
                        value={selectedTrip}
                        onValueChanged={setLoad}
                    />
                </div>
            </div>
            {stops.filter(stop => stop.tripId == selectedTrip.id).length > 0 &&
                <div className="test-barcodes-select-stop-selectbox-container">
                    <div className="test-barcodes-select-label">Stop:</div>
                    <div className="test-barcodes-select-box">
                        <SelectBox
                            dataSource={stops.filter(stop => stop.tripId == selectedTrip.id)}
                            placeholder={"Select a Stop"}
                            itemRender={renderStop}
                            displayExpr={findStop}
                            value={selectedStop}
                            onValueChanged={(e: any) => setSelectedStop(e.value)}
                        />
                    </div>
                </div>
            }
            {selectedStop.id != null &&
                <Fragment>
                    {lineItems.length > 0 &&
                        <div className={'test-barcodes-container'}>
                            <div className={'card-material test-barcodes-filter-container'}>
                                <div className={'test-barcodes-filter-checkbox'}>
                                    <CheckBox name={'Items'} value={isItemSelected} onValueChanged={(e: any) => setIsItemSelected(e.value)} />
                                    <div>Items</div>
                                </div>
                                <div className={'test-barcodes-filter-checkbox'}>
                                    <CheckBox name={'LPs'} value={isLpSelected} onValueChanged={(e: any) => setIsLpSelected(e.value)} />
                                    <div>LPs</div>
                                </div>
                                <div className={'test-barcodes-filter-checkbox'}>
                                    <CheckBox name={'Returns'} value={isReturnItemSelected} onValueChanged={(e: any) => setIsReturnItemSelected(e.value)} />
                                    <div>Returns</div>
                                </div>
                                <SearchBox placeHolder={'search'} searchQuery={query} onSearch={query => setQuery(query.toLowerCase())} />
                            </div>
                            <ScrollView height={"80vh"} >
                                <div>
                                    {filteredItems.map(item => <BarcodeCard key={item.id} heading={item.longDescription ?? item.description ?? 'Unknown Item'} barcode={item.universalProductCode} />)}
                                    {filteredLps.map(lp => <BarcodeCard key={lp.id} heading={`LP: ${lp.id}`} barcode={lp.id} />)}
                                    {filteredReturnItems.map(ri => {
                                        const lineItem: LineItem = returnItemLineItem.find(li => li.id == ri.lineItemId) ?? { } as LineItem;
                                        return <BarcodeCard key={ri.id} heading={`Return: ${lineItem.longDescription}`} barcode={lineItem.universalProductCode} />
                                    })}
                                </div>
                            </ScrollView>
                        </div>
                    }
                    {lineItems.length == 0 &&
                        <div className="test-barcodes-no-items">There are no items at this stop</div>
                    }
                </Fragment>
            }
        </Fragment>
    )
};
